// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import {
  CheckCircle2,
  Clock,
  ExternalLink,
  Download,
  Trash2,
  CalendarPlus,
} from 'lucide-react';

export default function AuditFormCard({
  form,
  formLabel,
  onOpen,
  onDownload,
  onToggleStatus,
  onDelete,
  onNextMonth,
}) {
  const done = form.status === 'concluido';
  return (
    <Card
      className={`hover:shadow-md transition-shadow ${
        done ? 'border-emerald-300 dark:border-emerald-700' : ''
      }`}
      data-testid={`form-card-${form.id}`}
    >
      <CardContent className="p-3 sm:p-4 relative overflow-hidden">
        {done && (
          <div className="absolute top-0 right-0 bg-emerald-500 text-white text-[10px] font-bold px-6 py-0.5 rotate-45 translate-x-5 -translate-y-0.5 shadow-sm">
            CONCLUÍDO
          </div>
        )}
        <div className="flex items-start gap-3">
          <div
            className={`w-9 h-9 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
              done ? 'bg-emerald-100 dark:bg-emerald-900' : 'bg-amber-100 dark:bg-amber-900'
            }`}
          >
            {done ? (
              <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 dark:text-emerald-400" />
            ) : (
              <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-amber-600 dark:text-amber-400" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-foreground text-sm sm:text-base leading-tight">
              <span className="text-[11px] font-bold text-muted-foreground mr-1">
                {formLabel}
              </span>
              {form.title}
            </h3>
            <div className="flex flex-wrap items-center gap-1.5 mt-1">
              <span
                className={`text-[11px] px-1.5 py-0.5 rounded-full ${
                  done
                    ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300'
                    : 'bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300'
                }`}
              >
                {done ? 'Concluído' : 'Em andamento'}
              </span>
              <span className="text-[11px] text-muted-foreground">
                {form.created_by_name} - {new Date(form.created_at).toLocaleDateString('pt-BR')}
              </span>
            </div>
          </div>
        </div>
        <div className={`grid ${onNextMonth ? 'grid-cols-6' : 'grid-cols-5'} gap-1 mt-2.5 pt-2 border-t border-border sm:flex sm:items-center sm:gap-1 sm:border-0 sm:mt-0 sm:pt-0 sm:absolute sm:right-3 sm:top-1/2 sm:-translate-y-1/2`}>
          <Button
            variant="default"
            size="sm"
            onClick={() => onOpen(form)}
            className="col-span-2 h-9 text-xs sm:text-sm"
            data-testid={`open-form-${form.id}`}
          >
            <ExternalLink className="w-3.5 h-3.5 mr-1" /> Preencher
          </Button>
          {onNextMonth && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => onNextMonth(form)}
              title="Gerar folha do mês seguinte"
              className="h-9 flex items-center justify-center"
              data-testid={`next-month-form-${form.id}`}
            >
              <CalendarPlus className="w-4 h-4" />
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={() => onDownload(form)}
            title="Baixar PDF"
            className="h-9 flex items-center justify-center"
          >
            <Download className="w-4 h-4" />
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onToggleStatus(form)}
            title={done ? 'Reabrir' : 'Concluir'}
            className="h-9 flex items-center justify-center"
          >
            {done ? <Clock className="w-4 h-4" /> : <CheckCircle2 className="w-4 h-4" />}
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onDelete(form)}
            className="h-9 flex items-center justify-center text-destructive hover:text-destructive"
            title="Excluir"
            data-testid={`delete-form-${form.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
